import React, { Component } from "react";
import ReportBadge from "./ReportBadge";
import classNames from "classnames";

export default class ReportChart extends Component {
  render() {
    const {
      id,
      className,
      // `eyebrow` and `number` are used by the V2 report; V1 passes neither and
      // renders exactly as before.
      eyebrow,
      number,
    } = this.props;

    return (
      <div className="report__page__wrapper" id={id}>
        <div
          className={classNames(
            "report__page",
            "report_page--split_12",
            className,
            { "report__page--numbered": number !== undefined },
          )}
        >
          <div
            className="report__info report__section--padding"
            style={{ paddingRight: 0 }}
          >
            {eyebrow && <p className="report-v2__eyebrow">{eyebrow}</p>}
            <h2 dangerouslySetInnerHTML={{ __html: this.props.title }} />
            <h3 dangerouslySetInnerHTML={{ __html: this.props.subtitle }} />
            <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
          </div>
          <div className="report__chart">{this.props.children}</div>
          {number !== undefined && (
            <span className="report-v2__page-number">{number}</span>
          )}
        </div>
        {this.props.options}
        {number === undefined && (
          <ReportBadge light={className === "report__page--dark"} />
        )}
      </div>
    );
  }
}
